<!-- @format -->
<ng-container *transloco="let t">
  @if (gradeRaiseAttemptCourseUnit$ | async; as data) {
    <sis-study-notification-box
      [useFudisLink]="true"
      type="approved"
      [tertiaryButtonText]="getOpenDialogTranslationKeyWhenCompletionMethodSelected(data)"
      (tertiaryClickAction)="openSelectCompletionMethodModal()">
      {{ t("PLAN.GRADE_RAISE_COMPLETION_METHOD_CHOSEN", { completion_method_index: getCompletionMethodIndex(data) }) }}
    </sis-study-notification-box>
  }
</ng-container>
